// AdsBox.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { FaWindowClose } from 'react-icons/fa';


const Box = styled.div`
  position: relative;
  width: 160px;
  height: 144px;
  border-radius: 8px;
  margin: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  
  &:hover .delete-icon {
    opacity: 1;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  img, video {
    width: 100%;
    height: 100%;
    object-fit: ${props => {
      switch(props.type) {
        case 'main':
          return 'cover';  // 16:9
        case 'banner':
          return 'cover';  // 2.75:1
        case 'side':
          return 'contain'; // 9:16
        default:
          return 'cover';
      }
    }};
    background-color: #f0f0f0;
  }
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  
  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;

const NoImage = styled.span`
  color: #666;
  font-size: 0.9rem;
`;


const AdsBox = ({adsId,  url, adsType, fileType, duration, onDelete, onEdit }) => {
    const getMediaUrl = (url) => {
      return `https://kr.object.ncloudstorage.com/qnoss/runningtrack/ads/${url}`;
    };
  return (
    <Box>
      <ImageContainer
        type={fileType}
        onClick={() =>{
            console.log('AdsBox onClick : ', onEdit)
            onEdit({ adsId, url, adsType, fileType, duration })
        }}
    >
        {url ? (
          fileType === 'image' ? (
            <img 
              src={getMediaUrl(url)} 
              alt="광고" 
            />
          ) : (
            <video 
              src={getMediaUrl(url)} 
              autoPlay 
              muted 
              loop 
            />
          )
        ) : (
          <NoImage>No Image</NoImage>
        )}
      </ImageContainer>
      <DeleteButton 
        className="delete-icon"
        onClick={() => onDelete(adsId)}  // 함수 호출 방식 수정
      >
        <FaWindowClose />
      </DeleteButton>
    </Box>
  );
};

export default AdsBox;